export default __webpack_public_path__ + "static/media/V89Pw2yAPHk.b37e35a2.jpg";